export interface TableViewOption {
  facetCode: string;
  tableHeaders: Array<TableHeader>;
}

export interface TableHeader {
  key: string;
  sortable: boolean;
  sortingOption1?: string;
  sortingOption2?: string;
}

export const TABLE_VIEW_OPTIONS: TableViewOption[] =
  [
    {
      facetCode: "idr",
      tableHeaders: [
        {
          key: "model",
          sortable: true,
          sortingOption1: "+nigenso3",
          sortingOption2: "-nigenso3"
        },
        {
          key: "manufacturer",
          sortable: true,
          sortingOption1: "+nigenso1",
          sortingOption2: "-nigenso1"
        },
        {
          key: "options",
          sortable: false
        }
      ]
    }
  ]
